/* eslint-disable unused-imports/no-unused-imports */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import {
	ExternalTransferHeadersRequestDto,
	ExternalTransferApiService,
	TransferBaseRequestDto,
	ExternalTransferHeadersResponseDto,
	ExternalTransferDescriptionDto,
	TransferBaseResponseDto
} from '@api/external-transfer';
import { NavController } from '@ionic/angular';
import { Observable, firstValueFrom, Subject, switchMap, takeUntil, tap, from } from 'rxjs';
import { map } from 'rxjs';
import {
	ItemPickerOptionModel,
	ItemPickerModel,
	ToastService,
	ToastDuration,
	FileModel,
	AppVariables,
	AppRoutingKeys,
	LoadingIndicatorState, User, ErrorCodes, StorageService
} from '@shared';
import { TransferOutStateService, ItemPickerFactoryService } from './services';
import { LoggingStyles, ItemPickerTypeEnum } from './models';
import { StructureTransferOutStrategy, DataAndStructureTransferOutStrategy } from './strategies';
import { AuthProvider } from '@domain/authentication';
import { ImportStatusEnum } from '@shared/plugins';
import { TranslateService } from '@ngx-translate/core';
import {
	DataAndStructureTransferOutOrchestratorService,
	StructureTransferOutOrchestratorService
} from '@domain/json-file-importer';
import { ApiConnectionsModel, ApiConnectionsRepository, WorkspaceRepository } from '@database/central';
import { ApiConnectionSelectedOptions } from 'src/database/central-database/models/api-connections-selected-options.model';
import { ConnectionTypeEnum } from '../../../domain/connections/models';
import { ApiErrorModel } from '@api/http';
import { ViewConfigurationService } from 'src/domain/view-configuration';
import { LoggingService } from '@shared/logging';

@Component({
	selector: 'app-connection-options',
	templateUrl: 'connection-options.component.html',
	styleUrls: ['connection-options.component.scss'],
	providers: [TransferOutStateService]
})
export class ConnectionOptionsComponent implements OnInit, OnDestroy {
	@Input() public connectionId: string;
	@Input() public workFileId: string;
	@Input() public isAppendData: boolean;
	@Input() public connectionType: ConnectionTypeEnum;
	@Input() public isEditMode: boolean;
	@Output() public confirmAction: EventEmitter<any> = new EventEmitter();
	@Output() public importStatusAction: EventEmitter<ImportStatusEnum> = new EventEmitter();

	public displayBackButton$: Observable<boolean> = this.workfileRepository.hasWorkfilesImported$();
	public importStatus = ImportStatusEnum.noImport;
	public importStatusEnum = ImportStatusEnum;
	public connectionTypeEnum = ConnectionTypeEnum;
	public readyForSubmit: boolean;

	public environmentPickerModel: ItemPickerModel = this.itemPickerFactoryService.create(
		ItemPickerTypeEnum.ENVIRONMENT
	);
	public businessUnitsPickerModel: ItemPickerModel = this.itemPickerFactoryService.create(
		ItemPickerTypeEnum.BUSINESS_UNIT
	);
	public dhlLoggingStylePickerModel: ItemPickerModel = this.itemPickerFactoryService.create(
		ItemPickerTypeEnum.DHL_LOGGING_STYLE
	);
	public sstnLoggingStylePickerModel: ItemPickerModel = this.itemPickerFactoryService.create(
		ItemPickerTypeEnum.SSTN_LOGGING_STYLE
	);
	public descriptionsPickerModel: ItemPickerModel = this.itemPickerFactoryService.create(
		ItemPickerTypeEnum.DESCRIPTIONS
	);

	private isNewConnection = true;
	private unsubscriber$: Subject<boolean> = new Subject<boolean>();
	private selectedLoggingStyle: LoggingStyles;

	public constructor(
		private navController: NavController,
		private externalTransferApiService: ExternalTransferApiService,
		private transferOutSstateService: TransferOutStateService,
		private toastService: ToastService,
		private itemPickerFactoryService: ItemPickerFactoryService,
		private structureTransferOutStrategy: StructureTransferOutStrategy,
		private dataAndStructureTransferOutStrategy: DataAndStructureTransferOutStrategy,
		private authProvider: AuthProvider,
		private loadingIndicator: LoadingIndicatorState,
		private structureTransferOutOrchestratorService: StructureTransferOutOrchestratorService,
		private dataAndStructureTransferOutOrchestratorService: DataAndStructureTransferOutOrchestratorService,
		private translateService: TranslateService,
		private apiConnectionsRepository: ApiConnectionsRepository,
		private workfileRepository: WorkspaceRepository,
		private loggingService: LoggingService,
		private viewConfigurationService: ViewConfigurationService,
		private storageService: StorageService
	) { }

	public async ngOnInit(): Promise<void> {
		const connectionOptions = await firstValueFrom(
			this.apiConnectionsRepository
				.getConnectionDetails$(this.connectionId)
				.pipe(map((connectionDetails: ApiConnectionsModel | null) => connectionDetails))
		);

		if (connectionOptions && connectionOptions.selectedOptions) {
			this.isNewConnection = false;
		}

		this.initializeDataSources(connectionOptions.selectedOptions);
		const authMethod = await this.authProvider.getAuthenticationMethod();

		this.transferOutSstateService.selectedEnvironment$
			.pipe(takeUntil(this.unsubscriber$))
			.subscribe((environment) => {
				this.initializeBusinessUnits(environment, connectionOptions.selectedOptions);
				this.initializeDhlLogingStyles(environment, connectionOptions.selectedOptions);
				this.initializeSstnLoggingStyles(environment, connectionOptions.selectedOptions);
			});

		this.transferOutSstateService.externalTransferHeadersPrerequisites$
			.pipe(
				tap(() => this.descriptionsPickerModel.updateIsLoading(true)),
				switchMap(([selectedEnvironment, selectedBusinessUnit, logginStyle]) => {
					this.selectedLoggingStyle = logginStyle;

					this.readyForSubmit = this.shouldSkipTransferOut();

					return this.externalTransferApiService.getExternalTransferHeaders$(
						this.connectionId,
						new ExternalTransferHeadersRequestDto({
							AuthenticationMethod: authMethod,
							Environment: selectedEnvironment,
							businessUnit: selectedBusinessUnit,
							loggingStyle: logginStyle.dhlLoggingStyle,
							sstnLoggingStyle: logginStyle.sstnLoggingStyle
						})
					);
				}),
				map((response: ExternalTransferHeadersResponseDto) => response.Data),
				map((descriptions: ExternalTransferDescriptionDto[]) =>
					descriptions.map(
						(d: ExternalTransferDescriptionDto) =>
							new ItemPickerOptionModel({
								displayName: d.TransferDescription,
								value: d.TransferId
							})
					)
				),
				takeUntil(this.unsubscriber$)
			)
			.subscribe(
				(descriptions: ItemPickerOptionModel[]) => {
					this.descriptionsPickerModel.updateIsLoading(false);
					this.descriptionsPickerModel.updateOptions(
						[
							new ItemPickerOptionModel({
								displayName: 'NEW',
								value: AppVariables.IMPORT_TRANSFER_OUT_DATA_STRUCTURE_OPTION
							})
						].concat(descriptions)
					);
				},
				async (error: ApiErrorModel) => {
					await this.toastService.presentError(error.errorMessage, ToastDuration.Fast);
					this.descriptionsPickerModel.updateIsLoading(false);
					this.descriptionsPickerModel.updateOptions(null);
				}
			);
	}

	public onEnvironmentSelected(environment: string[]): void {
		this.transferOutSstateService.setEnvironment(environment[0]);
		this.descriptionsPickerModel.updateOptions(null);
	}

	public onDhlLoggingStyleSelected(dhl: string[]): void {
		this.transferOutSstateService.setDhlLoggingStyle(dhl[0]);
	}

	public onSstnLoggingStyleSelected(sstn: string[]): void {
		this.transferOutSstateService.setSstnLoggingStyle(sstn[0]);
	}

	public onBusinessUnitSelected(businessUnit: string[]): void {
		this.transferOutSstateService.setBusinessUnit(businessUnit[0]);
	}

	public onDescriptionSelected(descriptions: string[]): void {
		this.transferOutSstateService.setExternalTransferId(descriptions[0]);
		this.readyForSubmit = true;
	}

	public isTransferOutInProgress(): boolean {
		return this.importStatus === ImportStatusEnum.importInProgress;
	}

	public async onSubmit(): Promise<void> {
		if (this.isNewConnection || this.isEditMode) {
			try {
				await this.apiConnectionsRepository.updateConnectionSelectedOptions(this.connectionId, {
					businessUnit: this.transferOutSstateService.selectedBusinessUnit.value,
					database: this.transferOutSstateService.selectedEnvironment.value,
					dhlLoggingStyle: this.transferOutSstateService.selectedDhlLoggingStyle.value,
					sstnLoggingStyle: this.transferOutSstateService.selectedSstnLoggingStyle.value
				});
			} catch (error) {
				await this.toastService.presentError(
					this.translateService.instant('connectionsModal.form.pathManually.errors.saveOptions'),
					ToastDuration.Fast
				);
			}
		}

		if (this.shouldSkipTransferOut()) {
			this.confirmAction.emit();
			return;
		}
		await this.transferOutWorkfile();
	}

	public goBack(): void {
		this.navController.pop();
	}

	public ngOnDestroy(): void {
		this.unsubscriber$.next(true);
		this.unsubscriber$.unsubscribe();
	}

	private shouldSkipTransferOut(): boolean {
		return (
			this.connectionType !== this.connectionTypeEnum.includeOptionsAndDescriptions || Boolean(this.isEditMode)
		);
	}

	private async transferOutWorkfile(): Promise<void> {
		let workfile: FileModel = {} as FileModel;

		const selectedDescription: string[] = this.descriptionsPickerModel.options
			.filter((item: ItemPickerOptionModel) => item.isSelected)
			.map((item: ItemPickerOptionModel) => item.displayName);

		this.loadingIndicator.setIsLoading(
			true,
			this.translateService.instant('importPage.transferOutOptions.loadingMessage')
		);

		const onlyStrctureOfWorkfile: boolean =
			this.transferOutSstateService.selectedExternalTransferId.value ===
			AppVariables.IMPORT_TRANSFER_OUT_DATA_STRUCTURE_OPTION;

		try {
			const fusionUserId: string = await this.authProvider.getFusionUserId();
			workfile = await this.validateWorkfile(onlyStrctureOfWorkfile);

			// validate fusion user access from transfer out
			if (!workfile.FusionUsers || workfile.FusionUsers.length === 0) {
				throw new Error('No Fusion Users list found in the imported file');
			}
			const userHasAccess = workfile.FusionUsers.find((user: User) => user.userid === fusionUserId);

			if (!userHasAccess) {
				throw new Error('You do not have access to this file. Please import another one.');
			}

		} catch (err) {
			this.loadingIndicator.setIsLoading(false);

			this.loggingService.error(ErrorCodes.FileValidatorHandlerFusionUserNoAccess, err);
			await this.toastService.presentError(
				this.translateService.instant(err.message),
				ToastDuration.Slow
			);
			return;
		}

		workfile.FileDisplayName = this.transferOutSstateService.getSuggestedName(
			onlyStrctureOfWorkfile,
			selectedDescription
		);
		workfile.apiConnectionId = this.connectionId;

		this.loadingIndicator.setIsLoading(false);
		this.importStatus = ImportStatusEnum.importInProgress;
		this.importStatusAction.emit(ImportStatusEnum.importInProgress);

		try {
			if (this.isAppendData) {
				await this.workfileRepository.appendDataToWorkfile(this.workFileId, workfile);
			} else {
				await this.saveWorkfile(onlyStrctureOfWorkfile, workfile);
				await this.viewConfigurationService.setTFWorkfile(workfile.workFileId)
			}

		} catch (err) {
			this.importStatus = ImportStatusEnum.importError;
			this.loggingService.error(ErrorCodes.ImportPageError, err);
			return;
		}

		await this.toastService.presentSuccess(
			this.translateService.instant('importPage.messages.importSuccessful'),
			ToastDuration.Fast
		);
		if (this.isAppendData) {
			await this.navController.navigateRoot(`/${AppRoutingKeys.urlPathWorkfile}/${this.workFileId}`);
		} else {
			await this.navController.navigateRoot(`/${AppRoutingKeys.urlPathWorkfile}/${workfile.workFileId}`);
		}

		await this.saveDatabaseUsingWorkfileId(workfile.workFileId, this.transferOutSstateService.selectedEnvironment.value);
	}

	public async saveDatabaseUsingWorkfileId(workspaceId: string, value: string): Promise<void> {
		await this.storageService.set(workspaceId +'_database', value);
	}

	private async validateWorkfile(onlyStrctureOfWorkfile: boolean): Promise<FileModel> {
		if (onlyStrctureOfWorkfile) {
			return await this.structureTransferOutStrategy.validate(
				this.connectionId,
				this.transferOutSstateService.selectedEnvironment.value,
				this.transferOutSstateService.selectedBusinessUnit.value,
				this.selectedLoggingStyle.dhlLoggingStyle,
				this.selectedLoggingStyle.sstnLoggingStyle
			);
		}

		return await this.dataAndStructureTransferOutStrategy.validate(
			this.connectionId,
			this.transferOutSstateService.selectedEnvironment.value,
			this.transferOutSstateService.selectedExternalTransferId.value
		);
	}

	private async saveWorkfile(onlyStrctureOfWorkfile: boolean, workfile: FileModel): Promise<void> {
		if (onlyStrctureOfWorkfile) {
			return await this.structureTransferOutOrchestratorService.startProcess(workfile);
		}

		return await this.dataAndStructureTransferOutOrchestratorService.startProcess(workfile);
	}

	private async initializeDataSources(
		apiConnectionPreselectedOptions: ApiConnectionSelectedOptions | null
	): Promise<void> {
		this.environmentPickerModel.updateIsLoading(true);

		this.externalTransferApiService
			.getDataSources(this.connectionId)
			.pipe(
				takeUntil(this.unsubscriber$),
				map((dataSources: string[]) =>
					dataSources.map(
						(method) =>
							new ItemPickerOptionModel({
								displayName: method,
								value: method
							})
					)
				)
			)
			.subscribe(
				(dataSources: ItemPickerOptionModel[]) => {
					this.environmentPickerModel.updateOptions(dataSources);
					this.preselectEnvironment(apiConnectionPreselectedOptions);
					this.environmentPickerModel.updateIsLoading(false);
				},
				async (error: ApiErrorModel) => {
					await this.toastService.presentError(error.errorMessage, ToastDuration.Fast);
					this.environmentPickerModel.updateIsLoading(false);
					this.environmentPickerModel.updateOptions(null);
				}
			);
	}

	private preselectEnvironment(apiConnectionPreselectedOptions: ApiConnectionSelectedOptions | null): void {
		if (apiConnectionPreselectedOptions) {
			this.onEnvironmentSelected([apiConnectionPreselectedOptions.database]);
			this.environmentPickerModel.selectItem(apiConnectionPreselectedOptions.database);
		}
	}

	private async initializeSstnLoggingStyles(
		env: string,
		apiConnectionPreselectedOptions: ApiConnectionSelectedOptions
	): Promise<void> {
		this.sstnLoggingStylePickerModel.updateIsLoading(true);

		const requestPayload = await this.getTransferOutRequestPayload(env);
		this.externalTransferApiService
			.getSstnLoggingStyles(this.connectionId, requestPayload)
			.pipe(takeUntil(this.unsubscriber$))
			.subscribe(
				(response: TransferBaseResponseDto) => {
					const loggingOptions = response.LoggingStyles ?? response.Data;
					this.sstnLoggingStylePickerModel.updateOptions(
						loggingOptions.map(
							(item: string) =>
								new ItemPickerOptionModel({
									displayName: item,
									value: item
								})
						)
					);
					this.preselectSSTNLoggingStyle(apiConnectionPreselectedOptions);
					this.sstnLoggingStylePickerModel.updateIsLoading(false);
				},
				async (error: ApiErrorModel) => {
					await this.toastService.presentError(error.errorMessage, ToastDuration.Fast);
					this.sstnLoggingStylePickerModel.updateIsLoading(false);
					this.sstnLoggingStylePickerModel.updateOptions(null);
				}
			);
	}

	private preselectSSTNLoggingStyle(apiConnectionPreselectedOptions: ApiConnectionSelectedOptions | null): void {
		if (apiConnectionPreselectedOptions && apiConnectionPreselectedOptions.sstnLoggingStyle) {
			this.onSstnLoggingStyleSelected([apiConnectionPreselectedOptions.sstnLoggingStyle]);
			this.sstnLoggingStylePickerModel.selectItem(apiConnectionPreselectedOptions.sstnLoggingStyle);
		}
	}

	private async initializeDhlLogingStyles(
		env: string,
		apiConnectionPreselectedOptions: ApiConnectionSelectedOptions
	): Promise<void> {
		this.dhlLoggingStylePickerModel.updateIsLoading(true);

		const requestPayload = await this.getTransferOutRequestPayload(env);
		this.externalTransferApiService
			.getDhlLoggingStyles(this.connectionId, requestPayload)
			.pipe(takeUntil(this.unsubscriber$))
			.subscribe(
				(response: TransferBaseResponseDto) => {
					const loggingOptions = response.LoggingStyles ?? response.Data;
					this.dhlLoggingStylePickerModel.updateOptions(
						loggingOptions.map(
							(item: string) =>
								new ItemPickerOptionModel({
									displayName: item,
									value: item
								})
						)
					);
					this.preselectDHLLoggingStyle(apiConnectionPreselectedOptions);
					this.dhlLoggingStylePickerModel.updateIsLoading(false);
					console.log(this.dhlLoggingStylePickerModel)
				},
				async (error: ApiErrorModel) => {
					await this.toastService.presentError(error.errorMessage, ToastDuration.Fast);
					this.dhlLoggingStylePickerModel.updateIsLoading(false);
					this.dhlLoggingStylePickerModel.updateOptions(null);
				}
			);
	}

	private preselectDHLLoggingStyle(apiConnectionPreselectedOptions: ApiConnectionSelectedOptions | null): void {
		if (apiConnectionPreselectedOptions && apiConnectionPreselectedOptions.dhlLoggingStyle) {
			this.onDhlLoggingStyleSelected([apiConnectionPreselectedOptions.dhlLoggingStyle]);
			this.dhlLoggingStylePickerModel.selectItem(apiConnectionPreselectedOptions.dhlLoggingStyle);
		}
	}

	private async initializeBusinessUnits(
		env: string,
		apiConnectionPreselectedOptions: ApiConnectionSelectedOptions
	): Promise<void> {
		this.businessUnitsPickerModel.updateIsLoading(true);

		const requestPayload = await this.getTransferOutRequestPayload(env);
		this.externalTransferApiService
			.getBusinessUnits(this.connectionId, requestPayload)
			.pipe(takeUntil(this.unsubscriber$))
			.subscribe(
				(response: TransferBaseResponseDto) => {
					const loggingOptions = response.LoggingStyles ?? response.Data;
					this.businessUnitsPickerModel.updateOptions(
						loggingOptions.map(
							(item: string) =>
								new ItemPickerOptionModel({
									displayName: item,
									value: item
								})
						)
					);
					this.preselectBusinessUnit(apiConnectionPreselectedOptions);
					this.businessUnitsPickerModel.updateIsLoading(false);
				},
				async (error: ApiErrorModel) => {
					await this.toastService.presentError(error.errorMessage, ToastDuration.Fast);
					this.businessUnitsPickerModel.updateIsLoading(false);
					this.businessUnitsPickerModel.updateOptions(null);
				}
			);
	}

	private preselectBusinessUnit(apiConnectionPreselectedOptions: ApiConnectionSelectedOptions | null): void {
		if (apiConnectionPreselectedOptions) {
			this.onBusinessUnitSelected([apiConnectionPreselectedOptions.businessUnit]);
			this.businessUnitsPickerModel.selectItem(apiConnectionPreselectedOptions.businessUnit);
		}
	}

	private async getTransferOutRequestPayload(env: string): Promise<TransferBaseRequestDto> {
		const authMethod = await this.authProvider.getAuthenticationMethod();

		return new TransferBaseRequestDto({
			Environment: env,
			AuthenticationMethod: authMethod
		});
	}

	public refreshPage() {
		this.importStatus = 0
		setTimeout(() => {
			this.ngOnInit()
			console.log('ios');
		}, 1000);

	}

	public doRefresh(event) {
		setTimeout(() => {
			this.ngOnInit()
			console.log('Async operation has ended');
			event.target.complete();

		});
	}
}
